import {ActionResponse, CaseInfo, CasesInfo, Fact, FormItem, SolutionItem, Solutions} from "./rest";

function hostname(): string {
  return window.location.port === "3000" ? "http://localhost:7010/" : "";
}

export const exportCases = hostname() + "cases/export";

function createURL(path: string) {
  return hostname() + path + window.location.search;
}

export async function completeCase(): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("cases/complete"),
    {
      method: "POST"
    }
  )).json();
}

export async function loadCase(loadCaseData: CaseInfo): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("cases/followUp"),
    {
      method: "POST",
      body: JSON.stringify(loadCaseData)
    }
  )).json();
}

export async function createCase(): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("cases/create"),
    {
      method: "POST"
    }
  )).json();
}

export async function getAllCases(request: Number): Promise<ActionResponse<CasesInfo>> {
  return await (await fetch(createURL("cases/all"),
    {
      method: "POST",
      body: JSON.stringify(request)
    }
  )).json();
}

export async function setFact(fact: Fact): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("form/setFact"),
    {
      method: "POST",
      body: JSON.stringify(fact)
    }
  )).json();
}

export async function removeFact(fact: Fact): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("form/removeFact"),
    {
      method: "POST",
      body: JSON.stringify(fact)
    }
  )).json();
}

export async function evaluation(): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("form/evaluation"),
    {
      method: "GET",
    }
  )).json();
}

export async function currentForm(): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("form/current"),
    {
      method: "POST",
    }
  )).json();
}

export async function homeForm(): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("form/home"),
    {
      method: "POST",
    }
  )).json();
}

export async function nextForm(): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("form/next"),
    {
      method: "POST",
    }
  )).json();
}

export async function previousForm(): Promise<ActionResponse<FormItem>> {
  return await (await fetch(createURL("form/previous"),
    {
      method: "POST",
    }
  )).json();
}

export async function getCurrentSolutions(): Promise<ActionResponse<Solutions>> {
  return await (await fetch(createURL("solution/all"))).json();
}

export async function setSolution(solution: SolutionItem): Promise<ActionResponse<boolean>> {
  return await (await fetch(createURL("solution/set"),
    {
      method: "POST",
      body: JSON.stringify(solution)
    }
  )).json();
}

export async function getKbVersion(): Promise<ActionResponse<string>> {
  return await (await fetch(createURL("kb/version"))).json();
}

export async function getKbLocation(): Promise<ActionResponse<string>> {
  return await (await fetch(createURL("kb/location"))).json();
}